/**
 * Created by Ivan on 04.02.2025
 */

const ButtonBoosterTutorial = function () {
    return new TutorialScenario("booster", {
        listSteps: ButtonBoosterTutorial.listSteps,
        isAvailable: ButtonBoosterTutorial.chooseAvailableBooster,

        onStart: function () {
            this.booster = ButtonBoosterTutorial.chooseAvailableBooster();
            this.booster.setFreePrice();
        },
        onFinish: function () {
            this.booster.setRegularPrice();
        }
    });
};
 
ButtonBoosterTutorial.listSteps = function () {
    const currentBooster = ButtonBoosterTutorial.chooseAvailableBooster();
    if (ButtonBoosterTutorial.CUSTOM_STEPS[currentBooster.id]) {
        return ButtonBoosterTutorial.CUSTOM_STEPS[currentBooster.id]();
    }

    return [ButtonBoosterTutorial.createClickButtonStep()];
};

ButtonBoosterTutorial.chooseAvailableBooster = function () {
    if (!cleverapps.environment.isGameScene()) {
        return false;
    }
    
    return cleverapps.boosters.listBoosters().find((booster) => booster.isForceAvailable());
};

ButtonBoosterTutorial.createClickButtonStep = function (finishEvent) {
    const booster = cleverapps.tutorial.getActive().booster;
    const button = booster.onGetView();
    finishEvent = finishEvent || "executeBooster";

    return new TutorialStep({
        onStart: function () {
            button.baseZOrder = button.getLocalZOrder();
            button.setLocalZOrder(0);

            cleverapps.focusManager.showControlsWhileFocused(
                cleverapps.boosters.listBoosters().filter((booster) => booster.isAvailable()).map((button) => button.getControlId())
            );

            new ActionPlayer([
                function (f) {
                    setTimeout(f, 700);
                },

                function (f) {
                    this.force = cleverapps.forces.create(button, booster.force, {
                        importantNodes: button.getForceImportantNodes(),
                        highlights: button.getForceHighlights()
                    });
                    cleverapps.forces.onceForceClosed = f;
                }.bind(this)
            ]).play();
           
            cleverapps.tutorial.on(finishEvent, this.finish.bind(this), this);
        },

        onFinish: function () {
            if (button.baseZOrder) {
                button.setLocalZOrder(button.baseZOrder);
            }

            Game.currentGame.counter.trigger();
        }
    });
};

ButtonBoosterTutorial.CUSTOM_STEPS = {};
ButtonBoosterTutorial.CUSTOM_STEPS[cleverapps.Boosters.TYPE_OPEN_LETTER] = function () {
    const booster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_OPEN_LETTER);
    const button = booster.onGetView();
    return [
        ButtonBoosterTutorial.createClickButtonStep("executeOpenLetterBooster"),
        new TutorialStep({
            onStart: function () {
                const wordComponent = ComponentMap.getByName(cleverapps.Scenes.GetRunningScene(), "WordGameSceneComponent");
                const movingNode = cleverapps.Scenes.GetMovingNode();

                this.force = cleverapps.forces.create(wordComponent.keypadView.letters[2], {
                    text: "OpenLetter.force2",
                    finger: {
                        delay: 1
                    }
                }, {
                    actives: [wordComponent.keypadView],
                    highlights: [wordComponent.keypadView, wordComponent.boardView, movingNode],
                    importantNodes: [wordComponent.keypadView, wordComponent.boardView, button.magnifier, button.closeButton]
                });

                cleverapps.tutorial.on("chooseLetter", this.finish.bind(this), this);
            },

            onFinish: function () {
                Game.currentGame.counter.trigger();
            }
        })];
};